import CSS from 'csstype';
import { GoogleMap, LoadScript } from '@react-google-maps/api';

const def:any = {
    lat: 20.849498,
    lng: -86.873782
};

const ViewMapComponent = ({ coords = def }) => {

    return (

        <LoadScript
            googleMapsApiKey="AIzaSyBB1rnW_OXrtG1_KKWBS_c9xlNFGj2FpVs"
        >
            <GoogleMap
                mapContainerStyle={mapStyles}
                center={coords}
                zoom={17}
            >
                { /* Child components, such as markers, info windows, etc. */}
                <></>
            </GoogleMap>
        </LoadScript>

    );
};

const mapStyles: CSS.Properties = {
    border: '0',
    width: 'calc(100vw)',
    marginLeft: '-14px',
    height: '300px'
}

export default ViewMapComponent;
